import { createRoutine } from 'redux-saga-routines';

export const loginRoutine = createRoutine('LOGIN'); 

export const logoutRoutine = createRoutine('LOGOUT'); 